<div [class]="'geactiveerd ' + data"></div>
<span [class]="data">{{data}}</span>
